import { List, Map } from 'immutable';
import { teamsTopTalentsListActions } from './actions';
import { TeamTopTalents, TopTalent } from './teams-top-talents-list';

export const initialState = new Map({
  currentTeamId: null,
});

export function teamsTopTalentsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_FAILED:
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_SUCCESS:
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_PENDING:
      return state.set(
        payload.teamId,
        teamTopTalentsReducer(state.get(payload.teamId), action)
      );

    case teamsTopTalentsListActions.LOAD_TEAM_TOP_TALENTS:
      return state.merge({
        currentTeamId: payload.teamId,
      });

    default:
      return state;
  }
}

export const teamTopTalentsReducer = (state = new TeamTopTalents(), action) => {
  const { type, payload } = action;

  switch (type) {
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_FAILED:
      return state.merge({
        isPending: false,
        error: payload.code
      });
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_SUCCESS:
      return state.withMutations(teamTopTalents => {
        teamTopTalents.merge({
          id: payload.teamId,
          never: List(payload.data.never_top_talents.map(talent => new TopTalent(talent))),
          always: List(payload.data.always_top_talents.map(talent => new TopTalent(talent))),
          isPending: false,
          error: null
        });
      });
    case teamsTopTalentsListActions.FETCH_TEAMS_TOP_TALENTS_PENDING:
      return state.set('isPending', true);
    default:
      return state;
  }
}